import React from 'react';
import ERPDashboard from './ERPDashboard';

/**
 * RoleSelectionMenu — replaced by the new hierarchical ERP Dashboard (BRD v3.0).
 * The ERPDashboard handles all Parent → Child navigation internally.
 */
const RoleSelectionMenu = ({ operator, onRoleSelected }) => {
  return <ERPDashboard operator={operator} onRoleSelected={onRoleSelected} />;
};

export default RoleSelectionMenu;
